import merge from 'lodash/merge';

class Cover {
  constructor(data) {
    this.alt = '';
    this.srcset = [];
    this.url = '';

    if (data) {
      merge(this, data);
    }
  }
}

export default Cover;
